import { useStore, State } from 'store';

import IAsync from 'types/IAsync';
import IAccount from 'types/IAccount';

export default function useAccountsAsync(): IAsync<IAccount[]> {
  return useStore((state: State) => state.accountsAsync);
}
